import { useEffect, useState } from "react";
import { TvRail, TvStage, useTvFeed } from "../components/TvScreens";

const NS = "urn:x-cast:com.myvelocity.tv";

export default function TvReceiver() {
  const feed = useTvFeed();
  const [i, setI] = useState(0);
  const [q, setQ] = useState(0);
  const [view, setView] = useState({ view: "carousel" });
  const [sender, setSender] = useState(null);
  useEffect(() => { const t = setInterval(() => setI((x) => x + 1), 8000); const t2 = setInterval(() => setQ((x) => x + 1), 12000); return () => { clearInterval(t); clearInterval(t2); }; }, []);
  useEffect(() => {
    const s = document.createElement("script");
    s.src = "https://www.gstatic.com/cast/sdk/libs/caf_receiver/v3/cast_receiver_framework.js";
    s.onload = () => {
      const cf = window.cast?.framework; if (!cf) return;
      const ctx = cf.CastReceiverContext.getInstance();
      ctx.addCustomMessageListener(NS, (ev) => { const m = ev.data || {}; setSender(ev.senderId); if (m.view) setView(m); if (m.next) setI((x) => x + 1); if (m.prev) setI((x) => Math.max(0, x - 1)); });
      const opts = new cf.CastReceiverOptions(); opts.disableIdleTimeout = true; opts.customNamespaces = { [NS]: cf.system.MessageType.JSON };
      ctx.start(opts);
    };
    document.body.appendChild(s);
    return () => { try { window.cast?.framework?.CastReceiverContext.getInstance().stop(); } catch { /* ignore */ } };
  }, []);
  return (
    <main className="fixed inset-0 bg-[#05080f] text-slate-100 grid grid-cols-[1fr_22vw]" data-testid="tv-receiver">
      <section className="relative h-full"><TvStage feed={feed} view={view} index={i} /></section>
      {feed && <TvRail feed={feed} quoteIndex={q} />}
      <p className="absolute left-[1vw] top-[1vh] text-[0.8vw] text-slate-600" data-testid="tv-receiver-status">{sender ? "Controlled from your phone/laptop" : "Connected · MY VELOCITY on TV"}</p>
    </main>
  );
}
